import React, { useState } from 'react';
import styled, { css } from 'styled-components';

const TooltipWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -16px;
`;

const Content = styled.p`
  border-radius: 5px;
  text-align: center;
  font-size: 12px;
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: normal;
  line-height: 17px;
  letter-spacing: -0.2px;
`;

const Tooltip = styled.div`
  height: 26px;
  width: 90px;
  position: absolute;
  border-radius: 4px;
  left: -0.8px;
  transform: translateX(-50%);
  padding: 8px;
  color: #ffffff;
  background: #070407;
  font-size: 14px;
  font-family: sans-serif;
  line-height: 1;
  z-index: 900;
  white-space: nowrap;

  ${props =>
    props.topLevel === true
      ? css`
          top: -28px;
        `
      : css`
          top: -30px;
        `}

  &:before {
    content: ' ';
    left: 50%;
    border: solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-width: 5px;
    margin-left: -5px;
    top: 100%;
    border-top-color: #070407;
  }
`;

const MenuTooltip = props => {
  let timeout;
  const [active, setActive] = useState(false);

  const showTip = () => {
    if (props.isAnyChildItemExpanded) {
      return;
    }
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };
  return (
    <TooltipWrapper onMouseEnter={showTip} onMouseLeave={hideTip}>
      {props.children}
      {active && (
        <Tooltip topLevel={props.topLevel}>
          <InnerWrapper>
            <Content>Drag to move</Content>
          </InnerWrapper>
        </Tooltip>
      )}
    </TooltipWrapper>
  );
};

export default MenuTooltip;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/MenuTooltip/index.jsx